// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p8-0";
export var discountCodeInput = "_p8-1";